import { YardBlockStore } from '@yard/stores/YardBlockStore'
import { action, computed, makeObservable } from 'mobx'
import {
  mapFlexibleBlockFormDataToCreateCommand,
  mapFlexibleBlockFormDataToUpdateCommand,
} from '../../helpers/flexible-block.mapper'
import { IFlexibleBlockFormData } from '../../models/yard-setup.model'
import { YardNodeViewStore } from './yard-node.view-store'

export class FlexibleBlockViewStore extends YardNodeViewStore<
  IFlexibleBlockFormData,
  YardBlockStore
> {
  constructor(yardBlockStore: YardBlockStore) {
    super(yardBlockStore)
    makeObservable(this, {
      setRotation: action,
      setPosition: action,

      focusedFlexibleBlock: computed,
    })
  }

  setRotation = (id: string, rotation: number) => {
    const block = this.entityStore.yardBlocks[id]

    if (block && block.type === 'FlexibleBlock' && block.layoutPosition.rotation !== rotation) {
      const layoutPosition = {
        ...block.layoutPosition,
        rotation: Math.round(rotation),
      }

      this.entityStore.updateLayoutPosition({
        ...layoutPosition,
        yardBlockId: id,
      })
    }
  }

  setPosition = (id: string, position: { x: number; y: number }) => {
    const block = this.entityStore.yardBlocks[id]

    if (
      block &&
      block.type === 'FlexibleBlock' &&
      (block.layoutPosition.x !== position.x || block.layoutPosition.y !== position.y)
    ) {
      const layoutPosition = {
        ...block.layoutPosition,
        x: Math.round(position.x),
        y: Math.round(position.y),
      }

      this.entityStore.updateLayoutPosition({
        ...layoutPosition,
        yardBlockId: id,
      })
    }
  }

  get focusedFlexibleBlock() {
    return this.editingId ? this.entityStore.yardBlocks[this.editingId] : undefined
  }

  async submit(formData: IFlexibleBlockFormData): Promise<void> {
    if (this.editingId) {
      const updateCommand = mapFlexibleBlockFormDataToUpdateCommand(formData, this.editingId)
      await this.entityStore.updateFlexibleBlock(updateCommand)
    } else {
      const createCommand = mapFlexibleBlockFormDataToCreateCommand(formData, this.viewportCenter)
      await this.entityStore.createFlexibleBlock(createCommand)
    }
  }

  async delete(id: string): Promise<void> {
    await this.entityStore.deleteYardBlock(id)
  }
}
